export const ICONAMP_BUNDLEID = 'weappIconfont_loadIconMap_json';
export const ICONMAP_PATH = "/api/file/visitstatic/iconfont/icons/svgs/iconMap.js";

export const ICONCHUNK_PATH_PREFIX = '/api/file/visitstatic/iconfont/icons/svgs/';
